import React from "react";
import PropTypes from "prop-types";
import getPathToAsset from "src/common/utils/get-path-to-asset";
import "./TrustpilotStars.scss";

const TrustpilotStars = (props) => {
  let stars = [];
  for (let i = 0; i < props.stars; i++) {
    stars.push(
      <img
        key={i}
        src={getPathToAsset("img/trustpilot-star.png")}
        alt="trustpilot-star"
      />
    );
  }

  return <div className="trustpilot-rating">{stars}</div>;
};

TrustpilotStars.propTypes = {
  stars: PropTypes.oneOf(["5", "4", "3", "2", "1"]),
  className: PropTypes.string,
};

TrustpilotStars.defaultProps = {
  stars: "5",
};

export default TrustpilotStars;
